import {IWSPMeshContext} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/contexts/MeshContext';
import {
    MeshNoteKeyboardHandlers,
    NoteKeyMapConfig
} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/mesh/MeshNoteKeyboardHandlers';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {ErrorPopupSide, ErrorStyle, Input, InputStyle} from '@mintdata-wsp/wsp/ui/components/forms/Input';
import {bind} from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {action, computed} from 'mobx';
import {inject, observer} from 'mobx-react';
import * as React from 'react';
import {HotKeys} from 'react-hotkeys';

const styles = require('@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/notes/NoteView.less');
const cx = classnames.bind(styles);

interface IInputViewProps
{
    ctx?:IWSPMeshContext;
}

const NOTE_WIDTH:number = 178;
const NOTE_HEIGHT:number = 96;

@inject('ctx')
@observer
export class NoteView extends React.Component<IInputViewProps, any>
{
    private _noteTitleElement:HTMLElement = null;
    private _noteTextElement:HTMLElement = null;

    public render():JSX.Element
    {
        const {ctx} = this.props;
        const meshState = controllers.ui.spreadsheets.mesh.getState(ctx);
        const {isEditNoteMode} = meshState.details;
        const noteState = meshState.note;

        const {note} = noteState;

        // const title = noteState.notes ? noteState.notes.title : '';
        const text = noteState.note ? noteState.note.text : '';

        return isEditNoteMode && (
            <HotKeys keyMap={NoteKeyMapConfig} handlers={MeshNoteKeyboardHandlers.getHandlers(ctx)}>
                <div
                    style={this._style}
                    className={cx('meshNote')}
                >
                    <div
                        className={cx('title')}
                    >
                        <Input
                            className={cx('editor')}
                            inputClassName={cx('editorInput')}
                            style={InputStyle.Simple}
                            initialValue={note.title}
                            onChange={this._onTitleChange}
                            onRef={this._onTitleRef}
                        />
                    </div>

                    <div
                        className={cx('text')}
                    >
                        {/*ref={this._onNoteRef}*/}
                        <Input
                            multiline
                            className={cx('editor')}
                            inputClassName={cx('editorInput')}
                            style={InputStyle.Simple}
                            initialValue={note.text}
                            onChange={this._onTextChange}
                            placeholder={'Enter text'}
                            isInitiallyFocused
                            onRef={this._onTextRef}
                            width={note.width}
                            height={note.height}
                        />
                    </div>
                </div>
            </HotKeys>
        );
    }

    @action.bound
    private _onTitleChange(newValue:string)
    {
        const {ctx} = this.props;
        const meshState = controllers.ui.spreadsheets.mesh.getState(ctx);
        const noteState = meshState.note;

        noteState.note.title = newValue;
    }

    @action.bound
    private _onTextChange(newValue:string)
    {
        const {ctx} = this.props;
        const meshState = controllers.ui.spreadsheets.mesh.getState(ctx);
        const noteState = meshState.note;

        noteState.note.text = newValue;
    }

    @computed
    private get _style():React.CSSProperties
    {
        const {ctx} = this.props;
        const meshState = controllers.ui.spreadsheets.mesh.getState(ctx);
        const {note, details: {visibleWidth, visibleHeight}} = meshState;

        const {activeCellBounds: {x, y, width, height}} = note;

        const deltaToRightEdge:number = visibleWidth - (x + width);
        const deltaToBottomEdgeFromTop:number = visibleHeight - y;
        const deltaToBottomEdgeFromBottom:number = visibleHeight - (y + height);

        let translateX:number, translateY:number = y;
        let maxWidth:number = -1;

        if( deltaToRightEdge - 3 >= NOTE_WIDTH )
        {
            translateX = x + width - 3;

            if( deltaToBottomEdgeFromTop < NOTE_HEIGHT )
                translateY = visibleHeight - NOTE_HEIGHT;
        }
        else if ( x > NOTE_WIDTH )
        {
            translateX = x - NOTE_WIDTH;

            if( deltaToBottomEdgeFromTop < NOTE_HEIGHT )
                translateY = visibleHeight - NOTE_HEIGHT;
        }
        else
        {
            translateX = x;
            translateY = y + height;
            maxWidth = Math.min(width, visibleWidth);

            if( deltaToBottomEdgeFromBottom < NOTE_HEIGHT )
                translateY = y - NOTE_HEIGHT;
        }

        return {
            transform: `translate(${translateX}px, ${translateY}px)`,
            maxWidth: maxWidth > -1 ? `${maxWidth}px` : 'none',
            // minWidth: `${width}px`,
            // height: `${height}px`,
        };
    }

    @bind
    private _onTextRef(element:HTMLTextAreaElement):void
    {
        const {meshNote} = controllers.ui.spreadsheets;
        const {ctx} = this.props;

        this._noteTextElement = element;

        meshNote.setNoteTextRef(ctx, element || null);
    }

    @bind
    private _onTitleRef(element:HTMLInputElement):void
    {
        const {meshNote} = controllers.ui.spreadsheets;
        const {ctx} = this.props;

        this._noteTitleElement = element;

        meshNote.setNoteTitleRef(ctx, element || null);
    }
}
